import { render, staticRenderFns } from "./DangerClassCreateOrUpdate.vue?vue&type=template&id=cbe7a4aa&"
import script from "./DangerClassCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./DangerClassCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports